"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _get = _interopRequireDefault(require("./get"));

var _push = _interopRequireDefault(require("./push"));

var _splice = _interopRequireDefault(require("./splice"));

var _pipeWith = _interopRequireDefault(require("./util/pipeWith"));

var _default = (0, _unmutable.default)({
  name: "move",
  all: function all(fromIndex, toIndex) {
    return function (value) {
      var valueToMove = (0, _get.default)(fromIndex)(value);
      var insert = (0, _splice.default)(toIndex, 0, valueToMove);

      if (toIndex < 0) {
        insert = toIndex === -1 ? (0, _push.default)(valueToMove) : (0, _splice.default)(toIndex + 1, 0, valueToMove);
      }

      return (0, _pipeWith.default)(value, (0, _splice.default)(fromIndex, 1), insert);
    };
  }
});

exports.default = _default;